import { FormField, FormGrid } from '@dixa/lib-shared-habla';
import { useFormContext } from 'react-hook-form';

import { MimUserAvatarControl } from 'app/views/layout/views/settings/views/chatbots/components/components/mimUserAvatarControl/mimUserAvatarControl';
import { HookFormText } from 'components/hookForm';

export const ChatbotIdentity = (): JSX.Element => {
  const { control } = useFormContext();

  return (
    <FormGrid>
      <FormField>
        <FormField>
          <MimUserAvatarControl />
        </FormField>
      </FormField>
      <FormField>
        <HookFormText
          name="name"
          label="Internal reference"
          control={control}
          rules={{
            required: 'Internal reference is required',
          }}
          helpIcon={{
            text: 'The reference of your bot for internal purposes.',
            dark: true,
          }}
        />
      </FormField>

      <FormField>
        <HookFormText
          name="userName"
          label="Public display name"
          control={control}
          rules={{
            required: 'Public display name is required',
          }}
          helpIcon={{
            text: 'The name that your users will see while interacting with the bot.',
            dark: true,
          }}
        />
      </FormField>
    </FormGrid>
  );
};
